import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  effect,
  input,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatHint, MatLabel } from '@angular/material/form-field';
import { SiaTranslatePipe } from '@sia/shared';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
import { SiaErrorHintComponent } from '../sia-error-hint/sia-error-hint.component';

@Component({
  selector: 'sia-choice-check-box',
  templateUrl: './sia-choice-check-box.component.html',
  styleUrls: ['./sia-choice-check-box.component.scss'],
  standalone: true,
  imports: [
    MatCheckbox,
    FormsModule,
    SiaTranslatePipe,
    MatLabel,
    MatHint,
    SiaErrorHintComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaChoiceCheckBoxComponent extends SiaBaseEditorSignalComponent {
  @HostBinding('class.disabled')
  get hostDisabled() {
    return this.isDisabled();
  }

  choiceTrue = signal<boolean | null>(null);
  choiceTrueLabel = input<string>('Si');
  choiceFalse = signal<boolean | null>(null);
  choiceFalseLabel = input<string>('No');

  constructor() {
    super();

    // Sync internal checkbox state when the external value input changes
    effect(() => {
      const v = this.value();
      if (v === false) {
        this.choiceFalse.set(true);
        this.choiceTrue.set(false);
      } else if (v === true) {
        this.choiceTrue.set(true);
        this.choiceFalse.set(false);
      } else {
        this.choiceTrue.set(false);
        this.choiceFalse.set(false);
      }
    });
  }

  onValueChange($event: any, isFalse: boolean) {
    if (this.isDisabled()) return;
    if (isFalse) {
      this.choiceFalse.set($event);
      this.choiceTrue.set(false);
    } else {
      this.choiceTrue.set($event);
      this.choiceFalse.set(false);
    }
    if (this.choiceFalse()) {
      this.value.set(false);
    } else if (this.choiceTrue()) {
      this.value.set(true);
    } else {
      this.value.set(null);
    }
  }
}
